// Smooth scroll to element on page load if hash exists in URL
document.addEventListener('DOMContentLoaded', () => {
  const hash = window.location.hash;
  if (hash) {
    const targetId = hash.substring(1); // Remove '#' from the hash
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      setTimeout(() => {
        scrollToTarget(targetElement);

        // Open the accordion if it's a collapsible section
        if (targetElement.classList.contains('accordion-collapse')) {
          targetElement.classList.add('show'); // Open the accordion
          const button = document.querySelector(`[data-bs-target="#${targetId}"]`);
          if (button) {
            button.classList.remove('collapsed'); // Ensure the button state is correct
          }
        }
      }, 0); // Delay to ensure DOM is ready
    }
  }
});

// Smooth scroll to clicked anchor link
function handleAnchorClick(e) {
  const targetUrl = this.getAttribute('href');
  console.log('Anchor clicked:', targetUrl);
  console.log('Current page:', window.location.href);
  
  if (isSamePageAnchor(targetUrl)) {
    console.log('Same page detected, preventing default');
    e.preventDefault(); // Prevent default anchor behavior

    const targetId = targetUrl.substring(targetUrl.indexOf('#') + 1);
    console.log('Target ID:', targetId);
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      console.log('Target element found, scrolling');
      scrollToTarget(targetElement);

      // Open the accordion if it's a collapsible section
      if (targetElement.classList.contains('accordion-collapse')) {
        targetElement.classList.add('show'); // Open the accordion
        const button = document.querySelector(`[data-bs-target="#${targetId}"]`);
        if (button) {
          button.classList.remove('collapsed'); // Ensure the button state is correct
        }
      }

      // Close the menu if it's a navigation link
      if (this.classList.contains('nav-link') || this.closest('.navbar-nav')) {
        collapseMenu();
      }
    } else {
      console.log('Target element not found for ID:', targetId);
    }
  } else {
    console.log('Different page, allowing normal navigation');
  }
}

// Add event listeners to existing anchor links
document.querySelectorAll('a[href*="#"]').forEach(anchor => {
  anchor.addEventListener('click', handleAnchorClick);
});

// Also handle dynamically added menu items (for dropdowns that might be added after page load)
document.addEventListener('click', function(e) {
  if (e.target.matches('a[href*="#"]')) {
    handleAnchorClick.call(e.target, e);
  }
});

// Function to scroll to target element smoothly
function scrollToTarget(target) {
  target.scrollIntoView({ behavior: 'smooth' });
}

// Function to check if the anchor is on the same page
function isSamePageAnchor(anchorUrl) {
  // Get the current page URL without hash and query parameters
  const currentUrl = new URL(window.location.href);
  const currentPath = currentUrl.pathname.replace(/\/$/, ''); // Remove trailing slash
  
  // Get the target URL without hash and query parameters
  const targetUrl = new URL(anchorUrl, window.location.origin);
  const targetPath = targetUrl.pathname.replace(/\/$/, ''); // Remove trailing slash
  
  // Compare the paths
  return currentPath === targetPath;
}

// Function to collapse the mobile menu and close dropdowns
function collapseMenu() {
  // Close mobile menu
  const body = document.body;
  const hamburger = document.querySelector('.hamburger');
  const mobileMenu = document.querySelector('.main-menu-mobile');
  const navbarToggler = document.querySelector('.navbar-toggler');
  
  if (body) {
    body.classList.remove('menu-active');
  }
  
  if (hamburger) {
    hamburger.classList.remove('is-active');
  }
  
  if (mobileMenu) {
    mobileMenu.classList.remove('show');
  }
  
  if (navbarToggler) {
    navbarToggler.classList.remove('collapse');
    navbarToggler.classList.remove('is-active');
    navbarToggler.classList.add('collapsed');
  }
  
  // Close Bootstrap dropdowns
  const dropdownMenus = document.querySelectorAll('.dropdown-menu.show');
  dropdownMenus.forEach(dropdown => {
    dropdown.classList.remove('show');
  });
  
  // Close Bootstrap offcanvas
  const offcanvas = document.querySelector('.offcanvas.show');
  if (offcanvas) {
    const offcanvasInstance = bootstrap.Offcanvas.getInstance(offcanvas);
    if (offcanvasInstance) {
      offcanvasInstance.hide();
    }
  }
}
